/**
 * Détecte automatiquement la saison et événements spéciaux
 * et retourne l'effet météo approprié
 */
export const getSeasonalWeatherEffect = () => {
  const now = new Date();
  const month = now.getMonth() + 1; // Janvier = 1, Décembre = 12
  const day = now.getDate();

  // Saint-Valentin (14 février ± 7 jours)
  if (month === 2 && day >= 7 && day <= 21) {
    return 'valentin';
  }

  // Hiver (Décembre, Janvier, Février) - Neige
  if (month === 12 || month === 1 || month === 2) {
    return 'snow';
  }
  
  // Printemps (Mars, Avril, Mai) - Fleurs
  if (month >= 3 && month <= 5) {
    return 'spring';
  }
  
  // Été (Juin, Juillet, Août) - Soleil
  if (month >= 6 && month <= 8) {
    return 'sun';
  }
  
  // Automne (Septembre, Octobre, Novembre) - Feuilles
  if (month >= 9 && month <= 11) {
    return 'autumn';
  }

  return 'none';
};

/**
 * Mélange la configuration avec la détection automatique
 */
export const applySeasonalEffect = (config) => {
  if (config.weatherEffect === 'auto') {
    return {
      ...config,
      weatherEffect: getSeasonalWeatherEffect()
    };
  }
  
  return config;
};